export default "__VITE_ASSET__DGc0YvhK__"